// English
export default {
  resdoc_title: "Restaurant Dashboard Documentation",
  resdoc_subtitle:
    "Everything you need to manage your restaurant operations smoothly and efficiently.",

  resdoc_profile_title: "Restaurant Profile Setup",
  resdoc_profile_1: "Restaurant name & contact details",
  resdoc_profile_2: "Address & service area",
  resdoc_profile_3: "Opening & closing timings",
  resdoc_profile_4: "GST, FSSAI & bank details",
  resdoc_profile_5: "Menu availability settings",

  resdoc_dashboard_title: "Dashboard Overview",
  resdoc_dashboard_1: "Today's Orders & revenue",
  resdoc_dashboard_2: "Total customers served",
  resdoc_dashboard_3: "Average customer ratings",
  resdoc_dashboard_4: "Order status breakdown",
  resdoc_dashboard_5: "Sales analytics & trends",

  resdoc_menu_title: "Menu Management",
  resdoc_menu_1: "Add, edit, or disable menu items",
  resdoc_menu_2: "Set pricing, images & categories",
  resdoc_menu_3: "Manage item availability",
  resdoc_menu_4: "Create combos & specials",

  resdoc_orders_title: "Orders Management",
  resdoc_orders_1: "Accept or reject incoming orders",
  resdoc_orders_2: "Modify orders if required",
  resdoc_orders_3: "Update order preparation status",
  resdoc_orders_4: "Track delivery completion",

  resdoc_issue_title: "Kitchen & Order Issues",
  resdoc_issue_1: "Send issues to kitchen staff",
  resdoc_issue_2: "Handle missing or modified items",
  resdoc_issue_3: "Resolve customer complaints",
  resdoc_issue_4: "Improve service quality",

  resdoc_inventory_title: "Inventory & Stock",
  resdoc_inventory_1: "Track raw material stock",
  resdoc_inventory_2: "Prevent shortages",
  resdoc_inventory_3: "Link inventory with menu items",
  resdoc_inventory_4: "Maintain optimal stock levels",

  resdoc_reports_title: "Reports & Analytics",
  resdoc_reports_1: "Daily, weekly & monthly sales",
  resdoc_reports_2: "Top selling dishes",
  resdoc_reports_3: "Customer behavior insights",
  resdoc_reports_4: "Operational performance metrics",

  resdoc_help_title: "Guided Tours & Help",
  resdoc_help_1: "Step-by-step dashboard walkthroughs",
  resdoc_help_2: "Menu & order tools guidance",
  resdoc_help_3: "Beginner-friendly onboarding",

  resdoc_footer:
    "Built to help your restaurant grow faster and serve better",
};